import { forwardRef, SelectHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { ChevronDown } from 'lucide-react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, options, placeholder, className, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={inputId} className="text-[11.5px] font-medium" style={{ color: 'var(--nucleo-ink-soft)' }}>
            {label}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            id={inputId}
            className={clsx('w-full appearance-none px-3 pr-8 text-[13px] outline-none transition-colors cursor-pointer', className)}
            style={{
              height: 34,
              background: 'var(--nucleo-surface)',
              border: error ? '1px solid var(--nucleo-danger)' : '1px solid var(--nucleo-line-mid)',
              color: 'var(--nucleo-ink)',
              fontFamily: 'inherit',
            }}
            {...props}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <ChevronDown className="pointer-events-none absolute right-2.5 top-2.5 h-4 w-4" style={{ color: 'var(--nucleo-dim)' }} />
        </div>
        {error && <p className="font-mono text-[10.5px]" style={{ color: 'var(--nucleo-danger)' }}>{error}</p>}
      </div>
    );
  }
);
Select.displayName = 'Select';
